import {Component, Input} from '@angular/core';
import {WarningComponent} from "../../warning/warning.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-purchase-not-allowed-warning',
  templateUrl: './purchase-not-allowed-warning.component.html',
  styleUrls: ['./purchase-not-allowed-warning.component.scss'],
  standalone: true,
  imports: [
    WarningComponent,
    NgIf
  ]
})
export class PurchaseNotAllowedWarningComponent {

  @Input()
  displayStudentEligiblityError: boolean;
  @Input()
  displayLicenseErrors: {
    student: boolean,
    employee: boolean,
    university: boolean
  };

  constructor() {
  }

}
